module.exports = "/* eslint react/no-multi-comp: 0, react/prop-types: 0 */\nimport React from 'react';\nimport { UncontrolledTooltip } from 'reactstrap';\n\nexport default function Example() {\n  return (\n    <div>\n      <p>Somewhere in here is a <span style={{textDecoration: \"underline\", color:\"blue\"}} href=\"#\" id=\"UncontrolledTooltipExample\">tooltip</span>.</p>\n      <UncontrolledTooltip placement=\"right\" target=\"UncontrolledTooltipExample\">\n        Hello world!\n      </UncontrolledTooltip>\n    </div>\n  );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./docs/lib/examples/TooltipUncontrolled.js
// module id = 433
// module chunks = 0